export { default } from "./ScrollFrameBody"
